var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"hamburger",class:{active: _vm.activeMenu},on:{"click":function($event){$event.stopPropagation();return _vm.emitToggle.apply(null, arguments)}}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hamburger-inner"},[_c('span',{staticClass:"hamburger-lines"})])
}]

export { render, staticRenderFns }